import styled from 'styled-components';

const FlippingCardContainer = styled.div`
  width: 100%;
  height: 200px;
`;

export { FlippingCardContainer };
